import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaitokolhapurcab() {



  const cardData = {
    keyword: " Navi Mumbai to Kolhapur Cab  ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai to Kolhapur cab service, providing safe, comfortable, and affordable long-distance travel for families, pilgrims, business travelers, and tourists. The distance between Navi Mumbai and Kolhapur is approximately 350–380 km, and the journey takes around 6–8 hours via well-connected national highways. Our professional drivers ensure a smooth and stress-free travel experience with timely pickup, safe driving, and well-maintained vehicles. We offer flexible options including one-way cab, round trip, and customized travel packages. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is your trusted choice for Navi Mumbai to Kolhapur cab service.",

"topPlaces": [
  {
    "title": "Mahalaxmi Temple Kolhapur",
    "description": "Mahalaxmi Temple is one of the most important pilgrimage sites in Maharashtra, dedicated to Goddess Mahalakshmi. It is also known as Ambabai Temple and is visited by lakhs of devotees every year. The temple is part of the Shakti Peethas and holds immense religious significance, especially for those completing pilgrimages after visiting Tirupati Balaji. The architecture of the temple reflects ancient craftsmanship, and the spiritual atmosphere attracts devotees seeking blessings, peace, and fulfillment of wishes."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake is a beautiful natural lake located in the heart of Kolhapur, known for its scenic surroundings and peaceful environment. Visitors enjoy evening walks, boating, horse riding, and local street food near the lake. The sunset views here are especially stunning, making it a favorite relaxation spot for tourists and locals alike. The lake area is well-developed with gardens and seating areas, making it ideal for families and photography lovers."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Jyotiba Temple is a famous religious site located on a hill near Kolhapur, dedicated to Lord Jyotiba. It is a significant pilgrimage destination where devotees visit throughout the year, especially during festivals when the temple is filled with pink-colored gulal celebrations. The temple offers panoramic views of the surrounding hills and countryside, making the journey both spiritual and scenic for visitors traveling from Navi Mumbai."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort is a historic hill fort associated with Chhatrapati Shivaji Maharaj and is one of the largest forts in the Deccan region. It is known for its strong architecture, historical importance, and breathtaking views of the Sahyadri mountains. Visitors can explore ancient structures, gates, and viewpoints while learning about Maratha history. The fort is also a popular destination for trekking and weekend trips."
  },
  {
    "title": "New Palace Museum",
    "description": "The New Palace Museum in Kolhapur showcases royal artifacts, weapons, costumes, and historical exhibits related to the Maratha Empire. It is a must-visit for history enthusiasts who want to explore the legacy of Kolhapur’s royal family. The palace architecture is impressive, combining Indian and European styles, and offers a glimpse into the lifestyle of past rulers."
  },
  {
    "title": "Radhanagari Wildlife Sanctuary",
    "description": "Radhanagari Wildlife Sanctuary is a lush green forest area located near Kolhapur, known for its biodiversity and natural beauty. It is home to animals like bison, deer, and various bird species, making it a great destination for nature lovers and wildlife enthusiasts. The sanctuary also offers peaceful surroundings, fresh air, and scenic landscapes ideal for eco-tourism."
  },
  {
    "title": "Dajipur Wildlife Sanctuary",
    "description": "Dajipur Wildlife Sanctuary, also known as Bison Sanctuary, is located on the border of Kolhapur and Sindhudurg districts. It is famous for Indian bison (gaur) and dense forest coverage. Visitors can enjoy jungle safaris, nature walks, and a refreshing escape from city life. The area becomes especially beautiful during monsoon and winter seasons."
  },
  {
    "title": "Kolhapuri Market",
    "description": "Kolhapuri Market is famous for traditional Kolhapuri chappals, jewelry, spices, jaggery, and local handicrafts. Tourists enjoy shopping for authentic products and experiencing the vibrant local culture. The market area is lively and offers a glimpse into the traditional lifestyle and craftsmanship of Kolhapur."
  },
  {
    "title": "Town Hall Museum",
    "description": "Town Hall Museum is another important cultural attraction in Kolhapur, showcasing sculptures, coins, paintings, and artifacts from different historical periods. It provides insight into the region’s artistic and cultural heritage, making it a valuable stop for history lovers."
  },
  {
    "title": "Narsinhwadi (Nearby Spiritual Place)",
    "description": "Narsinhwadi, also known as Narsobachi Wadi, is a sacred pilgrimage site located near Kolhapur at the confluence of Krishna and Panchganga rivers. It is dedicated to Lord Dattatreya and is visited by devotees seeking spiritual peace and blessings. The calm riverside environment adds to the devotional experience, making it a peaceful place to visit during the trip."
  }
],






services: [
  {
    name: "Mumbai to Kolhapur Cab",
    description: "Mumbai to Kolhapur cab service offers a comfortable long-distance journey ideal for family trips, business travel, and temple visits. The route ensures smooth highway travel with experienced drivers. Clean and well-maintained vehicles enhance comfort. It guarantees a safe and hassle-free journey."
  },
  {
    name: "Mumbai Airport to Kolhapur Cab",
    description: "Mumbai airport to Kolhapur cab provides direct transfer from airport terminals to Kolhapur city. Ideal for travelers arriving by flight, this service ensures timely pickup and smooth travel. Comfortable vehicles enhance convenience. It guarantees a stress-free journey."
  },
  {
    name: "Mumbai Kolhapur Cab Service",
    description: "Mumbai Kolhapur cab service offers reliable intercity transportation with multiple vehicle options. Suitable for family travel, corporate trips, and long-distance journeys. Professional drivers ensure safety. It ensures a smooth travel experience."
  },
  {
    name: "Mumbai to Kolhapur Car Rental",
    description: "Mumbai to Kolhapur car rental provides flexible vehicle options for personal and group travel. Customers can choose from sedan, SUV, and premium vehicles. Comfortable interiors enhance long-distance journeys. It ensures convenience and reliability."
  },
  {
    name: "Navi Mumbai to Kolhapur Cab",
    description: "Navi Mumbai to Kolhapur cab service offers direct and comfortable travel between cities. Ideal for families, tourists, and business travelers. Professional drivers ensure safe journeys. It guarantees a relaxed experience."
  },
  {
    name: "Navi Mumbai to Kolhapur Taxi",
    description: "Navi Mumbai to Kolhapur taxi provides private and flexible travel options for long-distance journeys. Comfortable seating ensures a pleasant ride. Suitable for individuals and groups. It guarantees a reliable journey."
  },
  {
    name: "Navi Mumbai to Kolhapur Cab Service",
    description: "Navi Mumbai to Kolhapur cab service ensures dependable transportation with clean vehicles and trained drivers. Ideal for outstation travel and family trips. Flexible booking enhances convenience. It ensures a safe journey."
  },
  {
    name: "Taxi from Navi Mumbai to Kolhapur",
    description: "Taxi from Navi Mumbai to Kolhapur offers reliable long-distance travel with experienced drivers. Smooth highway routes ensure comfortable journeys. Ideal for both business and leisure travel. It guarantees dependability."
  },
  {
    name: "Cab from Navi Mumbai to Kolhapur",
    description: "Cab from Navi Mumbai to Kolhapur provides convenient and comfortable travel for outstation trips. Ideal for families and group travel. Professional drivers ensure safety. It ensures a hassle-free experience."
  },
  {
    name: "Book Cab Navi Mumbai to Kolhapur",
    description: "Book cab Navi Mumbai to Kolhapur with easy online booking and instant confirmation. Customers can select vehicle type and travel timing. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Online Cab Booking Navi Mumbai to Kolhapur",
    description: "Online cab booking Navi Mumbai to Kolhapur provides a quick and convenient way to reserve your ride. Secure payment and instant confirmation enhance convenience. Multiple vehicle options are available. It ensures hassle-free booking."
  },
  {
    name: "Best Cab Navi Mumbai to Kolhapur",
    description: "Best cab Navi Mumbai to Kolhapur ensures top-quality vehicles, professional drivers, and excellent service. This service focuses on comfort, safety, and punctuality. It guarantees a premium travel experience."
  },
  {
    name: "Cheapest Cab Navi Mumbai to Kolhapur",
    description: "Cheapest cab Navi Mumbai to Kolhapur offers budget-friendly travel options without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "Reliable Taxi Navi Mumbai to Kolhapur",
    description: "Reliable taxi Navi Mumbai to Kolhapur provides dependable transportation with verified drivers and well-maintained vehicles. This service ensures timely pickups and safe journeys. It guarantees reliability."
  },
  {
    name: "One Way Cab Navi Mumbai to Kolhapur",
    description: "One way cab Navi Mumbai to Kolhapur offers cost-effective travel without return charges. Ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Round Trip Cab Navi Mumbai to Kolhapur",
    description: "Round trip cab Navi Mumbai to Kolhapur provides complete travel solutions including return journeys. Ideal for extended trips and vacations. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Outstation Cab Navi Mumbai to Kolhapur",
    description: "Outstation cab Navi Mumbai to Kolhapur offers reliable long-distance travel for business and leisure trips. Clean vehicles and professional drivers ensure comfort. It guarantees a smooth travel experience."
  },
  {
    name: "Innova Cab Navi Mumbai to Kolhapur",
    description: "Innova cab Navi Mumbai to Kolhapur offers spacious and comfortable travel for families and groups. Premium seating and smooth ride quality enhance long journeys. It ensures a comfortable travel experience."
  }
],

tableData: [
  ["Mumbai to Kolhapur Cab", "Mumbai Airport to Kolhapur Cab"],
  ["Mumbai Kolhapur Cab Service", "Mumbai to Kolhapur Car Rental"],
  ["Navi Mumbai to Kolhapur Cab", "Navi Mumbai to Kolhapur Taxi"],
  ["Navi Mumbai to Kolhapur Cab Service", "Taxi from Navi Mumbai to Kolhapur"],
  ["Cab from Navi Mumbai to Kolhapur", "Book Cab Navi Mumbai to Kolhapur"],
  ["Online Cab Booking Navi Mumbai to Kolhapur", "Best Cab Navi Mumbai to Kolhapur"],
  ["Cheapest Cab Navi Mumbai to Kolhapur", "Reliable Taxi Navi Mumbai to Kolhapur"],
  ["One Way Cab Navi Mumbai to Kolhapur", "Round Trip Cab Navi Mumbai to Kolhapur"],
  ["Outstation Cab Navi Mumbai to Kolhapur", "Innova Cab Navi Mumbai to Kolhapur"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai to Kolhapur Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Navi Mumbai to Kolhapur cab service, ideal for family trips, business travel, and long-distance journeys."
  },
  {
    WhyChooseheading: "Affordable Taxi Fare Options",
    WhyChoosedescription: "Taxi fare starts from approximately ₹3800 to ₹5000 for sedan and varies based on vehicle type and travel date." 
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai–Kolhapur highway routes, ensuring safe driving and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Kolhapur trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Navi Mumbai to Kolhapur cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Navi Mumbai to Kolhapur cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "What is the taxi fare from Navi Mumbai to Kolhapur?", answer: "Taxi fare starts from ₹3800–₹5000 for sedan and may go higher depending on vehicle type." },
  { question: "What is the distance between Navi Mumbai and Kolhapur?", answer: "The distance is approximately 350 to 380 km by road." },
  { question: "How much time does it take to reach Kolhapur?", answer: "It takes around 5 to 7 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Navi Mumbai to Kolhapur cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "What is SUV fare for this route?", answer: "SUV fares typically range from ₹5000 to ₹7000 depending on vehicle and package." },
  { question: "Can I book one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Navi Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshpande",
    feedback: "The Navi Mumbai to Kolhapur journey with Royal Route Cabs was very comfortable and well-managed. The driver ensured a safe and smooth long-distance ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback: "Excellent experience traveling from Navi Mumbai to Kolhapur. The cab was clean, the ride was smooth, and the service felt reliable throughout the journey.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Kolhapur Cab",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-to-kolhapur-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai to Kolhapur cab service with Royal Route Cabs for safe, comfortable, and reliable outstation travel. Available 24x7 with sedan, SUV, Innova, Innova Crysta, Ertiga, and premium vehicles for one-way and round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999", // approx starting fare (adjust as needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-to-kolhapur-cab"
  }
};








  return (
    <div>
<Helmet>
  <title>Navi Mumbai to Kolhapur Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Kolhapur cab with Royal Route Cabs. Safe and reliable outstation taxi service with Innova, Ertiga, Sedan, and Crysta options at affordable fares."
  />

  <meta
    name="keywords"
    content="mumbai to kolhapur cab, mumbai airport to kolhapur cab, mumbai kolhapur cab service, mumbai to kolhapur car rental, navi mumbai to kolhapur cab, navi mumbai to kolhapur taxi, navi mumbai to kolhapur cab service, taxi from navi mumbai to kolhapur, cab from navi mumbai to kolhapur, book cab navi mumbai to kolhapur, online cab booking navi mumbai to kolhapur, best cab navi mumbai to kolhapur, cheapest cab navi mumbai to kolhapur, reliable taxi navi mumbai to kolhapur, one way cab navi mumbai to kolhapur, round trip cab navi mumbai to kolhapur, outstation cab navi mumbai to kolhapur, innova cab navi mumbai to kolhapur, innova crysta cab navi mumbai to kolhapur, ertiga cab navi mumbai to kolhapur, swift dzire cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitokolhapurcab;